<template>
  <div
    v-if="context.request.user.is_staff"
    v-once
    class="text-caption-2 px-2 py-1 rounded d-inline-block bg-admin cursor-pointer"
  >
    <slot />
  </div>
</template>

<script setup lang="ts">
import type { ContextStore } from 'src/components/common/AdminButton/types'
import { useContextStore } from 'src/store'

const { context }: ContextStore = useContextStore()
</script>
